import {
	PortfolioPeriod,
	PortfolioPageTabValue,
} from 'src/components/PortfolioPage/types';
import { TabOption } from 'src/components/primitives/Tabs/types';
import { SNAPSHOTS_QUERY_MAX_DAYS } from 'src/hooks/query/snapshots/consts';

export const PORTFOLIO_TOOLTIP_COLLISION_PADDING = 8;

export const PORTFOLIO_PERIOD_TAB_OPTIONS: TabOption<PortfolioPeriod>[] = [
	{
		label: '24H',
		value: '24h',
	},
	{
		label: '7D',
		value: '7d',
	},
	{
		label: '30D',
		value: '30d',
	},
	{
		label: '90D',
		value: '90d',
	},
];

export const PORTFOLIO_DAYS_BY_PERIOD = {
	'24h': 1,
	'7d': 7,
	'30d': 30,
	// Some components require exactly 90 days, whereas the calendar can
	// can require more than 90 days depending on the months in range.
	//
	// In order to reduce the number of requests, we simply request max
	// days allowed and exclude the extra days for components that need
	// exactly 90.
	'90d': SNAPSHOTS_QUERY_MAX_DAYS,
};

export const PORTFOLIO_DEFAULT_PERIOD: PortfolioPeriod = '7d';

export const PORTFOLIO_PAGE_TAB_OPTIONS: TabOption<PortfolioPageTabValue>[] = [
	{
		label: 'Trade Portfolio',
		value: 'trade',
	},
	{
		label: 'Earn Portfolio',
		value: 'earn',
	},
	{
		label: 'History',
		value: 'history',
	},
	{
		label: 'Accounts',
		value: 'accounts',
	},
];

export const PORTFOLIO_PAGE_DEFAULT_TAB: PortfolioPageTabValue =
	PORTFOLIO_PAGE_TAB_OPTIONS[0].value;
